<template>
  <v-app id="app">
    <!-- <div v-if="!this.currentUser" class="bg-anon hide-on-small-only">
      <img v-if="this.bg" :src="this.bg" alt="">
    </div> -->

    <!-- <Navbar :user="this.currentUser" /> -->
    <header v-if="currentUser">
      <Navbar />
    </header>
    <!-- <header v-else>
      <AnonNavbar />
    </header> -->
    <div id="content-container">
      <v-content style="min-height: 100vh">
        <router-view/>
      </v-content>
    </div>
    
    <!-- <main>
      <v-content>
        <router-view/>
      </v-content>
    </main> -->
    <!-- <Footer v-if="this.currentUser" /> -->
    <!-- <v-row justify="center" align-content="center" no-gutters class="z1">
      <v-col class="py-4 text-center" cols="12" md="5">
        {{ new Date().getFullYear() }} - <strong>{{ siteName }}</strong>
      </v-col> -->
      <!-- <v-spacer></v-spacer>
      <v-col cols="6" md="2">
        <a href="https://agencia352.com" target="_blank">
          <v-img src="@/assets/352.png" position="center" width="100%" contain max-height="25px"></v-img>
        </a>
      </v-col> -->
    <!-- </v-row> -->

    <!-- <CompForm /> -->

    <!-- ------- SNACKBAR FEEDBACK -------- -->
    <v-snackbar v-if="getFeedback" :color="getFeedback.color" :class="getFeedback.textColor" v-model="getFeedback.show">
      {{getFeedback.message}}
      <v-btn :class="getFeedback.textColor" outlined @click="getFeedback.show = false" v-if="getFeedback.btnTxt">
        {{getFeedback.btnTxt}}
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Navbar from '@/components/layout/Navbar'
// import AnonNavbar from '@/components/layout/AnonNavbar'
// import Footer from '@/components/layout/Footer'
import firebase from 'firebase'
// import CompForm from '@/components/auth/CompForm'
import {mapGetters} from 'vuex';


export default {
  name: 'App',
  components: {
    Navbar,
    // AnonNavbar,
    // Footer,
    // CompForm,
  },
  data: () => ({
    currentUser: null,
    siteName: 'CMF Cursos',
    bg: null,
  }),
  computed: {
    ...mapGetters(['getFeedback', 'isUserAuth'])
  },
  mounted() {
    this.getUser()
    this.getBg()
  },
  beforeUpdate() {
    this.getUser()
  },
  methods: {
    getUser(){
      firebase.auth().onAuthStateChanged(user => {
        if (user){
          this.currentUser = user
          user.getIdTokenResult().then(idTokenResult => {
            this.admin = idTokenResult.claims.admin
          })
        } else {
          this.currentUser = null
        }
        // console.log(user)
      })
    },
    getBg(){
      // var storageRef = firebase.storage().ref();
      // var folderRef = storageRef.child('img')
      // var fileName = 'bg.png';
      // let bg = folderRef.child(fileName)
      // bg.getDownloadURL().then(imgUrl => {
      //   this.bg = imgUrl
      // })
    },
  }
};
</script>

<style lang="scss">
#content-container {
  width: 100% !important;
  padding: 0px;
  min-height: 100vh;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
</style>
